export default {
  metrics: {
    go_lives: 'Total Go Live-uri',
    avg_quality_score: 'Scor mediu de calitate',
    managers: {
      title: 'Manageri Onboarding',
      fields: {
        name: 'Nume manager',
        go_lives: 'Go Live-uri',
        avg_quality_score: 'Scor mediu calitate',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Nume proprietar',
    owner_phone: 'Telefon proprietar',
    owner_email: 'Email proprietar',
    live_from: 'Data Go-Live',
    onboarding_manager: 'Manager Onboarding',
    sales_manager: 'Manager Vânzări',
    onboarding_quality_score: 'Scor calitate',
    export_csv: 'Export CSV',
  },
};
